/* DDR Boutique — thème Shopify. Panier AJAX réel, mega menu, bannière, filtres, animations. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var motionOn = !reduce && typeof Element.prototype.animate === "function";
  var EASE = "cubic-bezier(.2,.8,.2,1)";
  var R = (window.DDR && window.DDR.routes) || { root: "/", cart: "/cart" };
  var root = R.root.replace(/\/?$/, "/");
  var EUR = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
  function money(cents) { return EUR.format((Number(cents) || 0) / 100); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  /* ------------------------------------------------------------ calques */
  var overlay = $("[data-overlay]"), openLayer = null;
  function openPanel(el) {
    closePanel();
    if (!el) return;
    el.hidden = false; overlay.hidden = false; openLayer = el;
    document.body.style.overflow = "hidden";
    var f = el.querySelector("button, a"); if (f) f.focus();
    if (motionOn) {
      var fromX = el.classList.contains("cart") ? "60px" : "-60px";
      el.animate([{ transform: "translateX(" + fromX + ")", opacity: 0 }, { transform: "none", opacity: 1 }], { duration: 320, easing: EASE });
      overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220 });
    }
  }
  function closePanel() {
    if (!openLayer) return;
    openLayer.hidden = true; overlay.hidden = true; openLayer = null;
    document.body.style.overflow = "";
  }
  overlay && overlay.addEventListener("click", function () { closePanel(); closeMega(); });
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-close]")) closePanel();
    if (e.target.closest("[data-open-drawer]")) openPanel($("[data-drawer]"));
    var oc = e.target.closest("[data-open-cart]");
    if (oc) { e.preventDefault(); openPanel($("[data-cart]")); refreshCart(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closePanel(); closeMega(); } });

  /* ------------------------------------------------------------ mega menu */
  var mega = $("[data-mega-panel]"), brandsPanel = $("[data-brands-panel]"), megaTimer;
  function closeMega() {
    [mega, brandsPanel].forEach(function (p) { if (p) p.hidden = true; });
    $$(".nav-item[aria-expanded]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  }
  function showMega(btn) {
    clearTimeout(megaTimer);
    var isBrands = btn.hasAttribute("data-brands");
    var panel = isBrands ? brandsPanel : mega, other = isBrands ? mega : brandsPanel;
    if (!panel) return;
    if (other) other.hidden = true;
    var wasHidden = panel.hidden;
    panel.hidden = false;
    $$(".nav-item[aria-expanded]").forEach(function (b) { b.setAttribute("aria-expanded", b === btn ? "true" : "false"); });
    if (!isBrands) {
      var id = btn.getAttribute("data-mega");
      $$(".mega-col", mega).forEach(function (c) { c.classList.toggle("is-active", c.getAttribute("data-col") === id); });
    }
    if (wasHidden && motionOn) {
      $$(".mega-col, .mega-brands-grid a", panel).forEach(function (c, i) {
        c.animate([{ transform: "translateY(8px)", opacity: 0 }, { transform: "none", opacity: 1 }], { duration: 280, delay: i * 18, easing: EASE, fill: "backwards" });
      });
    }
  }
  $$(".nav-item[data-mega], .nav-item[data-brands]").forEach(function (b) {
    b.addEventListener("mouseenter", function () { if (window.matchMedia("(hover: hover)").matches) showMega(b); });
    b.addEventListener("click", function () { if (b.getAttribute("aria-expanded") === "true") closeMega(); else showMega(b); });
  });
  var nav = $(".mainnav");
  if (nav) {
    nav.addEventListener("mouseleave", function () { megaTimer = setTimeout(closeMega, 220); });
    nav.addEventListener("mouseenter", function () { clearTimeout(megaTimer); });
    document.addEventListener("click", function (e) { if (!nav.contains(e.target)) closeMega(); });
  }
  $$(".mega-col").forEach(function (c) { c.addEventListener("mouseenter", function () { $$(".mega-col").forEach(function (x) { x.classList.toggle("is-active", x === c); }); }); });

  var header = $("[data-header]"), lastY = 0;
  window.addEventListener("scroll", function () {
    var y = window.scrollY;
    if (header) header.classList.toggle("is-compact", y > 80);
    if (Math.abs(y - lastY) > 40) { closeMega(); lastY = y; }
  }, { passive: true });

  /* ------------------------------------------------------------ panier (API panier Shopify) */
  var cartList = $("[data-cart-list]"), cartFoot = $("[data-cart-foot]");
  var cartState = null;
  try { cartState = JSON.parse($("#cart-initial").textContent); } catch (e) {}
  function emitCart(c) { try { document.dispatchEvent(new CustomEvent("ddr:cart", { detail: { total: (c.total_price || 0) / 100, count: c.item_count } })); } catch (e) {} }
  function renderCart(c) {
    if (!c) return;
    cartState = c;
    $$("[data-cart-count]").forEach(function (el) { el.textContent = c.item_count; });
    if (!cartList) return;
    if (!c.item_count) {
      cartList.innerHTML = '<div class="cart-empty"><p><strong>Votre panier est vide.</strong></p><a class="btn btn-dark btn-sm" href="' + root + 'collections/all">Voir la boutique</a></div>';
      cartFoot.hidden = true;
    } else {
      cartFoot.hidden = false;
      cartList.innerHTML = c.items.map(function (it, i) {
        var img = it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=160" : (window.DDR && window.DDR.star);
        var variant = it.variant_title && it.variant_title !== "Default Title" ? '<span class="b">' + esc(it.variant_title) + '</span>' : "";
        return '<div class="cart-line"><img src="' + esc(img) + '" alt="" width="68" height="68" loading="lazy"><div><span class="b">' + esc(it.vendor) + '</span><a class="t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<span class="lp"><span class="qty"><button type="button" aria-label="Retirer un" data-line="' + (i + 1) + '" data-qtyto="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Ajouter un" data-line="' + (i + 1) + '" data-qtyto="' + (it.quantity + 1) + '">+</button></span>' +
          '<button type="button" class="cart-remove" data-line="' + (i + 1) + '" data-qtyto="0">Retirer</button></span></div><strong>' + money(it.final_line_price) + '</strong></div>';
      }).join("");
      $("[data-cart-total]").textContent = money(c.total_price);
    }
    emitCart(c);
  }
  function refreshCart() { return fetch(root + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {}); }
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-line][data-qtyto]");
    if (!b) return;
    b.disabled = true;
    fetch(root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: Number(b.getAttribute("data-line")), quantity: Math.max(0, Number(b.getAttribute("data-qtyto"))) }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast("Impossible de modifier le panier."); });
  });
  function toast(msg) {
    var t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status"); t.textContent = msg;
    document.body.appendChild(t);
    if (motionOn) t.animate([{ transform: "translate(-50%, 20px)", opacity: 0 }, { transform: "translate(-50%, 0)", opacity: 1 }], { duration: 300, easing: EASE });
    setTimeout(function () { t.remove(); }, 2800);
  }
  function bump() { $$("[data-cart-count]").forEach(function (el) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }); }
  function fly(from) {
    var target = $("[data-open-cart]");
    if (!from || !target || !motionOn) return;
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!b.width) return;
    var d = document.createElement("span"); d.className = "fly-dot"; d.style.left = "0"; d.style.top = "0"; document.body.appendChild(d);
    var x0 = a.left + a.width / 2 - 8, y0 = a.top + a.height / 2 - 8, x1 = b.left + b.width / 2 - 8, y1 = b.top + b.height / 2 - 8, peak = Math.min(y0, y1) - 120, frames = [];
    for (var i = 0; i <= 12; i++) {
      var t = i / 12, ee = t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      frames.push({ transform: "translate(" + (x0 + (x1 - x0) * ee) + "px," + ((1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * peak + t * t * y1) + "px) scale(" + (1 - .6 * t) + ")", opacity: 1 - .5 * t });
    }
    d.animate(frames, { duration: 700, easing: "linear" }).onfinish = function () { d.remove(); };
  }
  function addItems(items, btn, openAfter) {
    if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); }
    return fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Erreur"); return j; }); })
      .then(function (res) {
        fly(btn);
        var n = (res.items || [res]).length;
        toast(n > 1 ? n + " produits ajoutés au panier" : "Ajouté au panier : " + ((res.items && res.items[0] && res.items[0].product_title) || res.product_title || ""));
        return refreshCart().then(function () { setTimeout(bump, motionOn ? 650 : 0); if (openAfter) openPanel($("[data-cart]")); });
      })
      .catch(function (err) { toast(err.message || "Impossible d'ajouter ce produit."); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute("aria-busy"); } });
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest("[data-add]");
    if (a) { e.preventDefault(); addItems([{ id: Number(a.getAttribute("data-add")), quantity: 1 }], a, false); return; }
    var m = e.target.closest("[data-add-many]");
    if (m) { e.preventDefault(); addItems(m.getAttribute("data-add-many").split(",").filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; }), m, true); }
  });
  renderCart(cartState);

  /* ------------------------------------------------------------ fiche produit */
  var form = $(".buy-form");
  if (form) {
    var idInput = $("[data-variant-id]", form), qtyInput = $("[data-qty]", form), submit = $("[data-add-submit]", form);
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      addItems([{ id: Number(idInput.value), quantity: Math.max(1, Number(qtyInput.value) || 1) }], submit, true);
    });
    $$("[data-q]", form).forEach(function (b) {
      b.addEventListener("click", function () { qtyInput.value = clamp((Number(qtyInput.value) || 1) + Number(b.getAttribute("data-q")), 1, 99); });
    });
    var sel = $("[data-variant-select]", form);
    if (sel) sel.addEventListener("change", function () {
      var o = sel.options[sel.selectedIndex];
      idInput.value = sel.value;
      $$(".price-big [data-price], .sticky-buy [data-price]").forEach(function (el) { el.textContent = o.getAttribute("data-price"); });
      var cmp = $("[data-compare]"); if (cmp) { cmp.textContent = o.getAttribute("data-compare"); cmp.hidden = !o.getAttribute("data-compare"); }
      var ok = o.getAttribute("data-available") === "true";
      submit.disabled = !ok; submit.textContent = ok ? "Ajouter au panier" : "Épuisé";
      var st = $("[data-stock]"); if (st) st.innerHTML = ok ? '<span class="stock ok"><i></i>En stock</span>' : '<span class="stock out"><i></i>Rupture de stock</span>';
      var vm = $("[data-vip-pdp]"); if (vm) { vm.setAttribute("data-price", Number(o.getAttribute("data-cents")) / 100); document.dispatchEvent(new CustomEvent("ddr:pdp")); }
      try { var u = new URL(location.href); u.searchParams.set("variant", sel.value); history.replaceState(null, "", u.toString()); } catch (err) {}
    });
    var sa = $("[data-sticky-add]");
    sa && sa.addEventListener("click", function () { form.requestSubmit ? form.requestSubmit() : submit.click(); });
  }
  $$("[data-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      var img = $(".gallery-main img");
      $$("[data-thumb]").forEach(function (x) { x.setAttribute("aria-pressed", x === t); });
      img.removeAttribute("srcset"); img.src = t.getAttribute("data-thumb");
      if (motionOn) img.animate([{ opacity: 0, transform: "scale(.97)" }, { opacity: 1, transform: "none" }], { duration: 300, easing: EASE });
    });
  });
  $$("[data-ptab]").forEach(function (t) {
    t.addEventListener("click", function () {
      var k = t.getAttribute("data-ptab");
      $$("[data-ptab]").forEach(function (x) { x.setAttribute("aria-selected", x === t); });
      $$("[data-ppanel]").forEach(function (p) { p.hidden = p.getAttribute("data-ppanel") !== k; });
    });
  });
  var zoom = $("[data-zoom]");
  if (zoom && window.matchMedia("(hover: hover)").matches) {
    zoom.addEventListener("mousemove", function (e) { var r = zoom.getBoundingClientRect(); zoom.style.setProperty("--zx", ((e.clientX - r.left) / r.width * 100) + "%"); zoom.style.setProperty("--zy", ((e.clientY - r.top) / r.height * 100) + "%"); zoom.classList.add("zoom"); });
    zoom.addEventListener("mouseleave", function () { zoom.classList.remove("zoom"); });
  }
  var sticky = $("[data-sticky-buy]"), buyRow = $("[data-buy-row]");
  if (sticky && buyRow && "IntersectionObserver" in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle("is-on", !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(buyRow);
  }
  // Produits associés (recommandations Shopify)
  $$("[data-recos]").forEach(function (box) {
    fetch(box.getAttribute("data-url")).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement("div"); d.innerHTML = html;
      var inner = d.querySelector("[data-recos]");
      if (inner && inner.querySelector(".p-card")) { box.innerHTML = inner.innerHTML; observeReveal(box); }
    }).catch(function () {});
  });

  /* ------------------------------------------------------------ catégorie : filtres et tri */
  var filters = $("[data-filters]");
  if (filters) {
    filters.addEventListener("change", function () { filters.requestSubmit ? filters.requestSubmit() : filters.submit(); });
  }
  var sortSel = $("[data-sort-select]");
  sortSel && sortSel.addEventListener("change", function () {
    var u = new URL(location.href); u.searchParams.set("sort_by", sortSel.value); u.searchParams.delete("page"); location.href = u.toString();
  });

  /* ------------------------------------------------------------ onglets de produits */
  $$("[data-rail]").forEach(function (t) {
    t.addEventListener("click", function () {
      var k = t.getAttribute("data-rail"), scope = t.closest("section") || document;
      $$("[data-rail]", scope).forEach(function (x) { x.setAttribute("aria-selected", x === t); });
      $$("[data-rail-panel]", scope).forEach(function (p) { p.hidden = p.getAttribute("data-rail-panel") !== k; });
      var shown = $('.p-grid[data-rail-panel="' + k + '"]', scope);
      if (shown) $$(".p-card", shown).forEach(function (c, i) { c.classList.add("in"); if (motionOn) c.animate([{ transform: "translateY(18px)", opacity: 0 }, { transform: "none", opacity: 1 }], { duration: 450, delay: i * 40, easing: EASE, fill: "backwards" }); });
    });
  });
  $$("[data-rail-prev], [data-rail-next]").forEach(function (b) {
    var r = document.getElementById(b.getAttribute("data-rail-prev") || b.getAttribute("data-rail-next"));
    if (!r) return;
    var dir = b.hasAttribute("data-rail-next") ? 1 : -1;
    b.addEventListener("click", function () { r.scrollBy({ left: dir * r.clientWidth * .9, behavior: reduce ? "auto" : "smooth" }); });
    var upd = function () { b.disabled = dir < 0 ? r.scrollLeft < 8 : r.scrollLeft + r.clientWidth > r.scrollWidth - 8; };
    r.addEventListener("scroll", upd, { passive: true }); upd();
  });

  /* ------------------------------------------------------------ bandeau promo + bannière publicitaire */
  var promo = $("[data-promo] ul");
  if (promo && promo.children.length > 1) {
    var pi = 0, pn = promo.children.length;
    setInterval(function () { pi = (pi + 1) % pn; promo.style.transform = "translateY(" + (-34 * pi) + "px)"; }, 4000);
  }
  $$("[data-hero]").forEach(function (hero) {
    var slides = $$("[data-slide]", hero), dots = $$("[data-dot]", hero), cur = 0, timer = null;
    var DUR = (Number(hero.getAttribute("data-duration")) || 6) * 1000;
    hero.style.setProperty("--dur", DUR + "ms");
    if (slides.length < 2) { hero.classList.toggle("light-ui", slides[0] && slides[0].classList.contains("light")); return; }
    var restart = function () { clearTimeout(timer); if (!reduce) timer = setTimeout(function () { go(cur + 1); }, DUR); };
    var go = function (i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-on", k === cur); s.setAttribute("aria-hidden", k === cur ? "false" : "true"); });
      dots.forEach(function (d, k) { d.classList.remove("is-on"); if (k === cur) { void d.offsetWidth; d.classList.add("is-on"); } d.setAttribute("aria-selected", k === cur); });
      hero.classList.toggle("light-ui", slides[cur].classList.contains("light"));
      restart();
    };
    dots.forEach(function (d) { d.addEventListener("click", function () { go(Number(d.getAttribute("data-dot"))); }); });
    var pv = $("[data-prev]", hero), nx = $("[data-next]", hero);
    pv && pv.addEventListener("click", function () { go(cur - 1); });
    nx && nx.addEventListener("click", function () { go(cur + 1); });
    hero.addEventListener("mouseenter", function () { clearTimeout(timer); hero.classList.add("paused"); });
    hero.addEventListener("mouseleave", function () { hero.classList.remove("paused"); restart(); });
    var sx = null;
    hero.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener("touchend", function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
    // Éditeur de thème : afficher la bannière sélectionnée
    document.addEventListener("shopify:block:select", function (e) { var i = slides.indexOf(e.target.closest ? e.target.closest("[data-slide]") : null); if (i > -1) { go(i); clearTimeout(timer); } });
    go(0);
  });

  /* ------------------------------------------------------------ newsletter, images manquantes */
  function fallback(img) { if (img.dataset.fb || !window.DDR) return; img.dataset.fb = "1"; img.removeAttribute("srcset"); img.src = window.DDR.star; img.style.opacity = ".15"; img.style.objectFit = "contain"; }
  document.addEventListener("error", function (e) { if (e.target.tagName === "IMG") fallback(e.target); }, true);

  /* ------------------------------------------------------------ mouvement au défilement */
  var io = null;
  function observeReveal(scope) {
    if (!motionOn || !io) { $$("[data-reveal]", scope).forEach(function (el) { el.classList.add("in"); }); return; }
    $$("[data-reveal]:not(.in)", scope).forEach(function (el) { io.observe(el); });
  }
  if (!motionOn) { document.documentElement.classList.remove("motion"); observeReveal(document); return; }
  io = new IntersectionObserver(function (entries) {
    var k = 0;
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target; io.unobserve(el); el.classList.add("in");
      el.animate([{ transform: "translateY(26px)", opacity: 0 }, { transform: "none", opacity: 1 }], { duration: 700, delay: (k++) * 60, easing: EASE, fill: "backwards" });
    });
  }, { rootMargin: "0px 0px -6% 0px" });
  observeReveal(document);
  // Sécurité : rien ne reste invisible (éditeur de thème, onglets cachés…)
  setTimeout(function () { $$("[data-reveal]:not(.in)").forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("in"); }); }, 2500);
  document.addEventListener("shopify:section:load", function (e) { observeReveal(e.target); });

  var vh = window.innerHeight;
  window.addEventListener("resize", function () { vh = window.innerHeight; });
  var fill = $("[data-steps-fill]"), stepsSec = $(".steps-sec"), steps = $$("[data-step]"), stepsCur = 0;
  function frame() {
    if (fill && stepsSec) {
      var r = stepsSec.getBoundingClientRect();
      var target = clamp((vh * .85 - r.top) / (vh * .5), 0, 1);
      stepsCur = lerp(stepsCur, target, .12);
      fill.style.transform = "scaleX(" + stepsCur.toFixed(4) + ")";
      steps.forEach(function (s, i) { s.classList.toggle("is-on", stepsCur >= (i + .3) / steps.length); });
    }
    requestAnimationFrame(frame);
  }
  if (fill) requestAnimationFrame(frame);
})();
